import styled from 'styled-components';

export const Main = styled.div`
  @supports not (
    (backdrop-filter: blur(50px)) or (-webkit-backdrop-filter: blur(50px))
  ) {
    background: #07021ae5;
  }

  opacity: 1;
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  position: fixed;
  width: 100%;
  top: 0;
  height: 12%;
  z-index: 2;

  @media (max-width: 960px) {
    position: absolute;
    background: #07021a 0% 0% no-repeat padding-box;
  }
`;

export const Content = styled.div`
  margin: 0 15.625%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  @media (max-width: 1024px) {
    margin: 0;
    justify-content: center;
  }

  @media (max-width: 960px) {
    margin: 0;
    justify-content: center;
  }
`;

export const InStationLogo = styled.img`
  width: 90%;

  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (max-width: 960px) {
    width: 80%;
  }
`;

export const Menu = styled.ul`
  display: flex;
  list-style: none;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    display: none;
  }

  @media (max-width: 960px) {
    display: none;
  }
`;

export const MenuItem = styled.li`
  a {
    font-size: 1.12rem;
    color: #ffffff;
    font-weight: 500;
    text-decoration: none;
  }
  margin-left: 2rem;
  padding: 0.3rem;
  ${props =>
    props.active &&
    `
      border-bottom: 2px solid #ee1f99;
    `}
`;

export const Terms = styled.li`
  a {
    font-size: 1.12rem;
    color: #ffffff;
    font-weight: 300;
    text-decoration: none;
  }
  margin-left: 2rem;
  padding: 0.3rem;
  ${props =>
    props.active &&
    `
      border-bottom: 2px solid #ee1f99;
    `}
`;
